var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M17.1,62c-2.3,0.7-6,4.5-6.6,6.8c-0.4,1.3-0.5,18.1-0.5,53.5V174l1.2,2.4c0.7,1.3,2,3,3,3.8c3,2.3,5.2,2.6,21.4,2.6h14.9v5.9v5.9h31.6h31.6v-5.9v-5.9h14.5c8.7,0,15.4-0.2,16.9-0.5c3.1-0.7,6-2.9,7.4-5.7l1.1-2.1v-52.3c0-49.8,0-52.4-0.9-54.3c-1.1-2.3-4.2-5.1-6.7-5.8C143.6,61.2,19.6,61.3,17.1,62z M145.3,69.5l1.2,1v51.1c0,28.1-0.1,51.4-0.3,51.9c-0.9,2.2,1,2.1-64.6,2.1H20.1l-1.5-1.2l-1.5-1.2V122V70.9l1.2-1.1l1.1-1.2h62.3H144L145.3,69.5z M106.6,185.1v2.4H81.8c-23.9,0-24.7,0-24.7-0.9c0-0.5,0.1-1.6,0.3-2.4l0.3-1.5h24.4h24.5L106.6,185.1L106.6,185.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M30.9,89.7v10.2h10.2h10.2V89.7V79.5H41.2H30.9V89.7z M45.7,89.7v4.5h-4.5h-4.5v-4.5v-4.5h4.5h4.5L45.7,89.7L45.7,89.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M83.3,85.9c0,0.4,12.8,44.7,13,44.9c0,0.1,2.3-3.1,5-7c2.7-3.9,5.1-7.2,5.3-7.4c0.2-0.1,2.7,2.3,5.5,5.3l5.2,5.5l2-2l2-2l-5-5.3c-2.8-3-4.9-5.6-4.8-5.8c0.1-0.2,3.7-2.4,7.9-4.9c4.2-2.4,7.6-4.5,7.5-4.6c-0.1-0.1-9.7-3.8-21.3-8.3c-11.7-4.5-21.5-8.2-21.7-8.4C83.5,85.7,83.3,85.7,83.3,85.9z M103,99.3c5.9,2.3,10.6,4.3,10.4,4.5c-0.1,0.2-2.1,1.4-4.4,2.8c-3.8,2.2-4.4,2.7-7.2,6.7c-1.7,2.4-3.2,4.3-3.3,4.3c-0.1,0-1.6-4.8-3.3-10.6c-1.7-5.8-3.1-10.8-3.2-11.2c-0.1-0.3-0.1-0.6,0-0.6C92.2,95.2,97.2,97,103,99.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M30.9,115.2v10.5h10.2h10.2v-10.5v-10.5H41.2H30.9V115.2z M45.7,115.2v4.8h-4.5h-4.5v-4.8v-4.8h4.5h4.5L45.7,115.2L45.7,115.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M28.1,153.5v9.3h14.3h14.3v-9.3v-9.3H42.3H28.1V153.5z M50.9,153.5v3.6h-8.6h-8.6v-3.6v-3.6h8.6h8.6V153.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M62.3,153.5v9.3H99h36.6v-9.3v-9.3H99H62.3V153.5z M129.9,153.5v3.6H99H68v-3.6v-3.6H99h30.9V153.5L129.9,153.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M163.9,62.5c-2.8,1.3-5,3.8-5.9,6.4c-0.8,2.6-0.8,115.5,0,118.1c0.8,2.6,3.1,5.1,5.9,6.4l2.4,1.1h35.2c26.3,0,35.6-0.1,37.1-0.6c2.6-0.8,6.1-4.3,6.9-6.9c0.8-2.9,0.8-115.5,0-118.4c-0.8-2.6-4.3-6.1-6.9-6.9c-1.5-0.4-10.8-0.6-37.1-0.6h-35.2L163.9,62.5z M237.6,69.7l1.2,1.1V128v57.1l-1.2,1.1l-1.1,1.2h-34.8h-34.8l-1.1-1.2l-1.2-1.1V128V70.9l1.2-1.1l1.1-1.2h34.8h34.8L237.6,69.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M197.7,74.4c-4.7,1.8-7.9,6.4-7.9,11.3c0,4.8,2.1,8.4,6.3,10.6c6.2,3.4,14,0.6,16.8-6.1c1.6-3.9,0.5-9.7-2.5-12.8C207.5,74.3,201.7,73,197.7,74.4z M204.6,80.2c3.2,1.7,4.4,5.9,2.4,9.1c-1,1.5-3.5,3-5.3,3c-1.8,0-4.3-1.5-5.3-3c-1-1.7-1.2-4.8-0.3-6.5C197.6,80,201.7,78.7,204.6,80.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M198.7,99.7c-3.7,1.3-6,4.6-6,8.5c0,3.9,1.9,6.8,5.5,8.4c2.6,1.2,4.9,1.1,7.7-0.3c3-1.5,4.6-3.8,4.9-7.1c0.3-3.3-0.5-5.5-2.8-7.6C205.1,99.1,202.1,98.5,198.7,99.7z M203.8,105.7c2.5,2.2,1.2,6.1-2,6.1s-4.7-4.2-2.2-6.1C201.2,104.4,202.3,104.5,203.8,105.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M171.3,143v12.1h30.4h30.4V143v-12.1h-30.4h-30.4V143z M226.5,143v6.4h-24.7H177V143v-6.4h24.7h24.7V143z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M171.3,169.6v12.1h30.4h30.4v-12.1v-12.1h-30.4h-30.4V169.6z M226.5,169.6v6.4h-24.7H177v-6.4v-6.4h24.7h24.7V169.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.c68ab77fc72b4ff8ffcf70294aa7d6a6.svg";
export { ForwardRef as ReactComponent };